import React from 'react';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { makeStyles } from '@material-ui/core/styles';

const useRowStyles = makeStyles({
    root: {
        '& > *': {
            borderBottom: 'unset',
        },
    },
});

export default function Row(props) {
    const [open, setOpen] = React.useState(false);
    const { row } = props
    const classes = useRowStyles();

    return (
        <React.Fragment>

            <TableRow className={classes.root}>
                <TableCell style={{ width: '3%' }} rowSpan={8}>
                    <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                </TableCell>

                <TableCell rowSpan={8} style={{ width: '20%', textAlign: 'center' }}>
                    {row.today_status === 'No Rain' ?
                        <React.Fragment>
                            <img src="http://hydrologywp.selfip.com/images/morning.png" alt="img" />
                            <Typography variant="body2">{row.today_status}</Typography>
                            <Typography variant="caption">Today Rain Highest</Typography>
                        </React.Fragment>
                        :

                        row.today_status === 'No Data' ?
                            <React.Fragment>
                                <img src="http://hydrologywp.selfip.com/images/morning_error.png" alt="img" />
                                <Typography variant="body2">{row.today_status}</Typography>
                                <Typography variant="caption">Today Rain Highest</Typography>
                            </React.Fragment>
                            :
                            null
                    }
                </TableCell>

                <TableCell style={{ width: '20%' }}>Total Rain: </TableCell>
                <TableCell style={{ width: '50%' }}>{row.today_total_rain}</TableCell>

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Current Water Level: </TableCell>
                <TableCell>{row.today_level}</TableCell>

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Highest Water Level: </TableCell>
                {row.today_highest_time === '' ?
                    <TableCell>{row.today_highest_level}</TableCell>
                    :
                    <TableCell>{row.today_highest_level} - {row.today_highest_time}</TableCell>
                }

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Lowest Water Level: </TableCell>
                {row.today_lowest_time === '' ?
                    <TableCell>{row.today_lowest_level}</TableCell>
                    :
                    <TableCell>{row.today_lowest_level} - {row.today_lowest_time}</TableCell>
                }

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Current Flow: </TableCell>
                <TableCell>{row.today_flow}</TableCell>

            </TableRow>
            
            <TableRow className={classes.root}>
                <TableCell>Highest Flow: </TableCell>
                {row.today_highest_flow_time === '' ?
                    <TableCell>{row.today_highest_flow_level}</TableCell>
                    :
                    <TableCell>{row.today_highest_flow_level} - {row.today_highest_flow_time}</TableCell>
                }

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Lowest Flow: </TableCell>
                {row.today_lowest_flow_time === '' ?
                    <TableCell>{row.today_lowest_flow_level}</TableCell>
                    :
                    <TableCell>{row.today_lowest_flow_level} - {row.today_lowest_flow_time}</TableCell>
                }

            </TableRow>

            <TableRow className={classes.root}>
                <TableCell>Date: </TableCell>
                <TableCell>{row.today_date}</TableCell>

            </TableRow>

            <TableRow>
                <TableCell colSpan={4}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Divider />
                            <br />
                            <Typography variant="h6" gutterBottom component="div"
                                style={{ textDecoration: 'underline', paddingLeft: '5rem' }}>
                                History
                            </Typography>
                            <br />
                            <Table size="small">
                                <TableBody>
                                    <TableRow className={classes.root}>
                                        <TableCell style={{ width: '10%' }} rowSpan={8}>
                                        </TableCell>
                                        <TableCell style={{ width: '20%', textAlign: 'center' }} rowSpan={8}>
                                            {row.ytd_status === 'No Rain' ?
                                                <React.Fragment>
                                                    <img src="http://hydrologywp.selfip.com/images/morning.png" alt="img" />
                                                    <Typography variant="body2">{row.ytd_status}</Typography>
                                                    <Typography variant="caption">Yesterday Highest Rain</Typography>
                                                </React.Fragment>
                                                :

                                                row.ytd_status === 'No Data' ?
                                                    <React.Fragment>
                                                        <img src="http://hydrologywp.selfip.com/images/morning_error.png" alt="img" />
                                                        <Typography variant="body2">{row.ytd_status}</Typography>
                                                        <Typography variant="caption">Yesterday Highest Rain</Typography>
                                                    </React.Fragment>
                                                    :
                                                    null
                                            }
                                        </TableCell>

                                        <TableCell style={{ width: '20%' }}>Total Rain: </TableCell>
                                        <TableCell style={{ width: '50%' }}>{row.ytd_total_rain}</TableCell>
                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Water Level: </TableCell>
                                        <TableCell>{row.ytd_level}</TableCell>

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Highest Water Level: </TableCell>
                                        {row.ytd_highest_time === '' ?
                                            <TableCell>{row.ytd_highest_level}</TableCell>
                                            :
                                            <TableCell>{row.ytd_highest_level} - {row.ytd_highest_time}</TableCell>
                                        }

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Lowest Water Level: </TableCell>
                                        {row.ytd_lowest_time === '' ?
                                            <TableCell>{row.ytd_lowest_level}</TableCell>
                                            :
                                            <TableCell>{row.ytd_lowest_level} - {row.ytd_lowest_time}</TableCell>
                                        }

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Flow: </TableCell>
                                        <TableCell>{row.ytd_flow}</TableCell>

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Highest Flow: </TableCell>
                                        {row.ytd_highest_flow_time === '' ?
                                            <TableCell>{row.ytd_highest_flow_level}</TableCell>
                                            :
                                            <TableCell>{row.ytd_highest_flow_level} - {row.ytd_highest_flow_time}</TableCell>
                                        }

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Lowest Flow: </TableCell>
                                        {row.ytd_lowest_flow_time === '' ?
                                            <TableCell>{row.ytd_lowest_flow_level}</TableCell>
                                            :
                                            <TableCell>{row.ytd_lowest_flow_level} - {row.ytd_lowest_flow_time}</TableCell>
                                        }

                                    </TableRow>

                                    <TableRow className={classes.root}>
                                        <TableCell>Date: </TableCell>
                                        <TableCell>{row.ytd_date}</TableCell>

                                    </TableRow>
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}